import { PropTypes } from 'prop-types';
import { Controller } from 'react-hook-form';
import MoneyInputStyled from './MoneyInput.styles';

export default function MoneyInput({
  name,
  value,
  control,
  width,
  height,
  label,
}) {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <MoneyInputStyled
              {...field}
              height={height}
              width={width}
              label={label}
              variant="filled"
              decimalCharacter=","
              digitGroupSeparator="."
              value={value}
              currencySymbol="R$"
              outputFormat="string"
              minimumValue="0"
              placeholder={label}
            ></MoneyInputStyled>
          </>
        )}
      ></Controller>
    </>
  );
}

MoneyInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
